import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';

const AlertModal = ({ isOpen, onClose, title, type, children, headerButtons, iconName, buttons, className }) => {
  const defaultButtons = buttons || [
    {
      name: 'close',
      text: 'buttonClose',
    },
  ];
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      title={title}
      type={type}
      buttons={defaultButtons}
      iconName={iconName || 'exclamation-triangle'}
      headerButtons={headerButtons}
      reverseButtons
      backDrop={false}
      className={className}
    >
      <div className="alert-modal">{children}</div>
    </Modal>
  );
};

AlertModal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AlertModal;
